module.exports = __webpack_public_path__ + "img/picture6.38b93e3e.png";